export const jumpToIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 24"><path fill="none" stroke="currentColor" stroke-width="1.5" d="M7.467 14.438H1m8.26-5.447H1m15.089-5.446H1m11.163 10.87c0 2.566 2.058 4.646 4.596 4.646s4.596-2.08 4.596-4.646-2.058-4.646-4.596-4.646-4.596 2.08-4.596 4.646zm11.163 6.636-3.331-3.338"/></svg>`,
    name: 'jump-to'
};